/**
 * Envío AP-4 · sesión de «Editar imagen» (una a la vez).
 * El escenario (sobre el preview o en el modal) y el panel de herramientas
 * leen y escriben acá. Nada se guarda hasta «Aplicar».
 */
import { create } from 'zustand';
import { applyPreset, defaultParams, normalizeParams } from '../utils/imageEdit';

const HISTORY_MAX = 40;

const useImageEditStore = create((set, get) => ({
  session: null,       // { key, source: {url,label,assetId}, origin: 'timeline'|'gallery'|'node', target? }
  params: defaultParams(),
  tool: 'rapidos',
  markTool: 'path',
  markColor: '#EF4444',
  markWidth: 6,
  history: [],
  saving: false,
  img: null,           // HTMLImageElement listo para leer píxeles (lo carga el escenario)

  loadError: null,
  setImg: (img, loadError = null) => set({ img, loadError }),
  estimate: null,      // AP-14 · {width,height,bytes,format,fits} de la pestaña «Tamaño»
  setEstimate: (estimate) => set({ estimate }),
  open: (session, params, opts = {}) => set({
    session,
    params: normalizeParams(params || {}),
    tool: opts.tool || 'rapidos',
    estimate: null,
    history: [],
    saving: false,
  }),
  close: () => set({ session: null, history: [], saving: false, img: null, loadError: null }),

  setTool: (tool) => set({ tool }),
  setMarkTool: (markTool) => set({ markTool }),
  setMarkColor: (markColor) => set({ markColor }),
  setMarkWidth: (markWidth) => set({ markWidth }),
  setSaving: (saving) => set({ saving: !!saving }),

  /** Cambio con historial (sliders: `commit=false` mientras se arrastra). */
  update: (patch, { commit = true } = {}) => {
    const { params, history } = get();
    const next = normalizeParams({ ...params, ...(typeof patch === 'function' ? patch(params) : patch) });
    set({
      params: next,
      history: commit ? [...history, params].slice(-HISTORY_MAX) : history,
    });
  },
  /** Guarda el estado actual en el historial (al empezar un arrastre). */
  checkpoint: () => set((s) => ({ history: [...s.history, s.params].slice(-HISTORY_MAX) })),
  preset: (id) => get().update(applyPreset(get().params, id)),
  undo: () => {
    const { history } = get();
    if (!history.length) return;
    set({ params: history[history.length - 1], history: history.slice(0, -1) });
  },
  reset: () => get().update(defaultParams()),
}));

export default useImageEditStore;
